import Vue from "vue";
import VueRouter from "vue-router";
import UpdateProfile from "../views/UpdateProfile";
import CreatePortfolio from "../views/CreatePortfolio";
import Login from "../views/Login";
import ForgotPassword from "../views/ForgotPassword";
import HomePage from "../views/home_page/HomePage";
import DetailPortfolio from "../views/portfolio/DetailPortfolio";
import AllPortfolioByDesign from "../views/portfolio/AllPortfolioByDesign";
import Register from "../views/Register";
import ProfilePortfolio from "../views/portfolio/ProfilePortfolio";
import Creator from "../views/portfolio/Creator";
import SubCurated from "../views/portfolio/SubCurated";
import MainLayout from "../views/MainLayout";
import AllPortfolioByCategory from "../views/portfolio/AllPortfolioByCategory";
import Verify from "../views/Verify";
import ProfileAbout from "../views/ProfileAbout";
import store from "../store";
import PortfolioByTag from "../views/portfolio/PortfolioByTag";
import ResetPassword from "../views/ResetPassword";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Content from "../views/Content";
import Pages from "../views/Pages";
import Contact from "../views/Contact";
import LandingPage from "../views/LandingPage";
import Search from "../views/portfolio/Search";
import TopRank from "../views/TopRank";
import PreviewPortfolio from "../views/portfolio/PreviewPortfolio.vue";
import Test from "../views/Test.vue";

Vue.use(VueRouter);
Vue.use(VueSweetalert2);

const routes = [
  {
    path: "/test",
    name: "Test",
    component: Test,
  },
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage,
  },
  {
    path: "/home",
    name: "LandingPage",
    component: LandingPage,
  },
  {
    path: "/homepage",
    name: "Mainlayout",
    component: MainLayout,
    children: [
      {
        path: "/homepage",
        name: "HomePage",
        component: HomePage,
      },
      {
        // path: "/detail/:slug",
        path: "/profile/:domain_slug/:portfolio_id_slug",
        name: "DetailPortfolio",
        component: DetailPortfolio,
      },
      {
        // path: "/detail/:slug",
        path: "/preview/:domain_slug/:portfolio_id_slug",
        name: "PreviewPortfolio",
        component: PreviewPortfolio,
      },
      {
        // path: "/all-portfolio-by-design",
        path: "/profile/:domain_slug",
        name: "AllPortfolioByDesign",
        component: AllPortfolioByDesign,
      },
      {
        path: "/profile-portfolio",
        name: "ProfilePortfolio",
        component: ProfilePortfolio,
      },
      {
        path: "/creator",
        name: "Creator",
        component: Creator,
      },
      {
        path: "/sub-curated",
        name: "SubCurated",
        component: SubCurated,
      },
      {
        path: "/portfolio-category/:slug",
        name: "AllPortfolioByCategory",
        component: AllPortfolioByCategory,
      },
      {
        path: "/portfolio-category/:slug/:subcate",
        name: "AllPortfolioByCategory",
        component: AllPortfolioByCategory,
      },
      {
        path: "/profile-about",
        name: "ProfileAbout",
        component: ProfileAbout,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/portfolio-tag",
        name: "PortfolioByTag",
        component: PortfolioByTag,
      },
      {
        path: "/content",
        name: "Content",
        component: Content,
      },
      {
        path: "/pages",
        name: "Pages",
        component: Pages,
      },
      {
        path: "/contact",
        name: "Contact",
        component: Contact,
      },
      {
        path: "/search",
        name: "Search",
        component: Search,
      },
      {
        path: "/toprank",
        name: "TopRank",
        component: TopRank,
      },
    ],
  },
  {
    // path: "/update-profile",
    path: "/profile-about/update",
    name: "UpdateProfile",
    component: UpdateProfile,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/forgot",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/profile-about/edit/:id",
    name: "GetUpdateProfile",
    component: UpdateProfile,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/create-portfolio",
    name: "CreatePortfolio",
    component: CreatePortfolio,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/portfolio/:id",
    name: "EditPortfolio",
    component: CreatePortfolio,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/verify",
    name: "Verify",
    component: Verify,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
];

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requireAuth)) {
    if (!store.state.auth.access_token) {
      alert("Please login...");
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
